<template>
  <BaiduMaps :config="parseExternalProps(config)" />
</template>

<script setup>
import BaiduMaps from '../../components/BaiduMaps/BaiduMaps.vue'
import { parseExternalProps } from '../../utils/parseExternalProps'

const props = defineProps({
  config: {
    type: String,
    default: undefined
  }
})

// eslint-disable-next-line no-unused-vars
const parsedConfig = parseExternalProps(props.config)
</script>
